// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3N0Z_","colMin":"styles_colMin__1MJVb","colCheckbox":"styles_colCheckbox__31cvf"};